export enum PageThemeKey {
  PostPurchase = 'Post-Purchase (orange)',
  Checkout = 'Checkout (blue)',
  Returns = 'Returns (purple)',
  Logistics = 'Logistics (teal)',
  CoPilot = 'Co-Pilot (dark blue)',
}
